import type { ApiError } from '@common/api/graphql/apolloClient';
import type {
  DownloadUrl,
  RequestInvoicePdfUrlResponse
} from '../../../../common/api/graphql/requestInvoicePdfUrlGql';
import { requestInvoicePdfUrl } from '../../../../common/api/graphql/requestInvoicePdfUrlGql';
import {
  requestInvoicePdfUrlFailure,
  requestInvoicePdfUrlStart,
  requestInvoicePdfUrlSuccess
} from '../actions';
import type { AppThunkAction } from '../thunkType';
import handleApiErrorIfNeeded from './handleApiErrorIfNeeded';

const requestInvoicePdfUrlSuccessThunk =
  (response: RequestInvoicePdfUrlResponse): AppThunkAction<Promise<string>> =>
  dispatch => {
    const { downloadUrl } = response.data!.requestInvoicePdfUrl;
    dispatch(requestInvoicePdfUrlSuccess());
    return Promise.resolve(downloadUrl);
  };

export const requestInvoicePdfUrlFailureThunk =
  (error: ApiError): AppThunkAction<Promise<void>> =>
  dispatch => {
    dispatch(requestInvoicePdfUrlFailure());
    return dispatch(handleApiErrorIfNeeded(error));
  };

export const requestInvoicePdfUrlThunk =
  (urlCode: UrlCode): AppThunkAction<Promise<DownloadUrl | void>> =>
  dispatch => {
    dispatch(requestInvoicePdfUrlStart());

    return requestInvoicePdfUrl(urlCode)
      .then((response: RequestInvoicePdfUrlResponse) =>
        dispatch(requestInvoicePdfUrlSuccessThunk(response))
      )
      .catch(error => dispatch(requestInvoicePdfUrlFailureThunk(error)));
  };
